module.exports = __webpack_public_path__ + "static/img/4.39f4d2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/zh/4.png
// module id = 1AlD
// module chunks = 0